// extracted by mini-css-extract-plugin
export var numpadContainer = "_fv-1";
export var phoneButton = "_fv-0";